<app-page>
  <div [ngSwitch]="step">
    <ng-container *ngSwitchCase="0">
      <ng-container *ngIf="pattern$ | async as p; else loading">
        <app-step-one [pattern]="p"> </app-step-one>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="1">
      <ng-container *ngIf="robotConfigs$ | async as robotConfigs; else loading">
        <app-step-two
          [robotConfigs]="robotConfigs"
          [selectedRobotConfigsOnInit]="selectedRobotConfigs"
          (selectedConfigsEmitter)="selectedRobotConfigs = $event"
        >
        </app-step-two>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="2">
      <ng-container
        *ngIf="
          {
            p: pattern$ | async,
            robotConfigs: selectedRobotConfigs
          } as summary;
          else loading
        "
      >
        <app-step-three
          [patternConfig]="pattern$ | async"
          [robotConfigs]="summary.robotConfigs"
        >
        </app-step-three>
      </ng-container>
    </ng-container>
  </div>

  <ng-template #loading>
    <app-loading></app-loading>
  </ng-template>
</app-page>

<app-wizard-bottom-navbar
  [title]="pages[step].header"
  [primaryButton]="step < 2 ? 'next' : 'confirm'"
  [secondaryButton]="step > 0 ? 'back' : null"
  (nextClick)="step === 2 ? runClick() : nextClick()"
  (backClick)="backClick()"
></app-wizard-bottom-navbar>
